import React from 'react';
import './TermsPage.css';

function TermsPage() {
  return (
    <div className="terms-page">
      <div className="terms-card">
        <h1>Условия за ползване</h1>

        <p>Добре дошли в услугата на Гуми Европа. Моля, прочетете внимателно тези Условия за ползване, преди да използвате нашия уебсайт и системата за запазване на часове. С използването на сайта вие се съгласявате с настоящите условия.</p>

        <h2>1. Услуга и обхват</h2>
        <p>Нашият уебсайт предоставя онлайн система за резервации на услуги свързани с гуми и автомеханични услуги. Ние си запазваме правото да променяме функционалността и съдържанието на сайта по всяко време.</p>

        <h2>2. Събиране и обработка на лични данни</h2>
        <p>За да извършите резервация, е необходимо да предоставите контактна информация и данни за превозното средство (например: име, телефон, регистрационен номер, марка/модел и детайли за избраната услуга). Тези данни се използват единствено за целите на изпълнение на резервацията и свързаното обслужване.</p>

        <h3>Период на съхранение</h3>
        <p>Личните данни, свързани с резервациите, се съхраняват за период от 1 (един) месец от датата на резервацията. След изтичане на този срок данните ще бъдат изтрити от нашите системи, освен ако не са необходими за изпълнение на законови задължения или в случай на злоупотреба, разследване или спор, който изисква по-дълъг срок на задържане.</p>

        <h3>Цел и правно основание</h3>
        <p>Правното основание за обработката е изпълнение на договор и предварителни действия по искане на субекта на данните (чл. 6(1)(b) от ДБН/ООД). Данните се обработват единствено за целите на резервиране, потвърждение и извършване на заявената услуга.</p>

        <h2>3. Използване за маркетингови цели</h2>
        <p>Ние НЕ използваме събраните данни за промоционални или маркетингови цели, освен ако не сте ни предоставили изрично писмено съгласие. Без вашето изрично съгласие ние няма да изпращаме търговски съобщения или да използваме данните ви за целите на реклама.</p>

        <h2>4. Сигурност и достъп</h2>
        <p>Прилагаме технически и организационни мерки за защита на данните срещу неразрешен достъп, изменение, разпространение или унищожаване. Достъп до личните данни имат само упълномощени служители и доставчици, нуждаещи се от тези данни за изпълнение на услугата.</p>

        <h2>5. Потребителски права</h2>
        <p>Като субект на данни вие имате следните права, приложими в съответствие с действащото законодателство:</p>
        <ul>
          <li>Право на достъп до личните ви данни;</li>
          <li>Право на корекция на неточни данни;</li>
          <li>Право да поискате изтриване на данните си (с изключение на случаи, когато законът ни задължава да ги запазим за по-дълъг период);</li>
          <li>Право да възразите срещу обработка, която е основана на нашия легитимен интерес;</li>
        </ul>

        <h2>6. Отговорност</h2>
        <p>Ние се стремим да поддържаме съдържанието на сайта актуално и правилно, но не даваме гаранции относно пълнотата или точността на информацията. Не носим отговорност за прекъсвания на услугата, загуба на данни или други щети, освен в случаите на умишлена или груба небрежност.</p>

        <h2>7. Промени в Условията</h2>
        <p>Ние можем да променяме тези Условия за ползване от време на време. Всяка съществена промяна ще бъде публикувана на тази страница с нова дата на влизане в сила. Продължаването на използването на услугата след публикуване на промени означава, че приемате тези промени.</p>

        <h2>8. Контакти</h2>
        <p>За въпроси относно Условията за ползване или упражняване на вашите права, моля свържете се с нас на:</p>
        <p>
          Гуми Европа<br />
          Телефон: +359 88 000 0000<br />
          Имейл: info@gumieuropa.example
        </p>

        <p className="terms-note">Дата на влизане в сила: 11 октомври 2025 г.</p>
      </div>
    </div>
  );
}

export default TermsPage;
